import styled from "styled-components";

export const FormDatePickerNewStyled = styled.div`
  .box_input_item {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }

  .error_message {
    color: ${({ theme }) => theme.COLORS.RED_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    margin-top: 4px;
    display: block;
  }
`;
